import { Backdrop, Button, Fade, Modal as MaterialUIModal } from '@material-ui/core';
import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

interface StyleModalProps {
    setWidth?: string;
    setHeight?: string;
    titleFontSize?: string;
    titleFontWeight?: string;
    bodyFontSize?: string;
    bodyFontWeight?: string;
    leftButtonSize?: string;
    leftButtonFontSize?: string;
    leftButtonFontWeight?: string;
    rightButtonSize?: string;
    rightButtonFontSize?: string;
    rightButtonFontWeight?: string;
    IsForPayment?: boolean;
}

const StyledModal = styled.div<StyleModalProps>`
    display: block;
    width: ${props => (props.setWidth ? props.setWidth : '256px')};
    height: ${props => (props.setHeight ? props.setHeight : '148px')};
    background-color: #fff;
    position: ${props => (props.IsForPayment ? 'fixed' : 'absolute')};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 18px;
    border-radius: 4px;
    ${props =>
        props.IsForPayment &&
        css`
            z-index: 30002 !important;
        `}

    .title {
        height: 23px;
        line-height: 23px;
        /* margin: 9px 8px 0px 10px; */
        margin-bottom: 23px;
        font-size: ${props => (props.titleFontSize ? props.titleFontSize : '16px')};
        font-weight: ${props => (props.titleFontWeight ? props.titleFontWeight : '500')};
        white-space: pre-line;
    }

    .icon_sns {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        font-size: 15px;
        line-height: 15px;
        margin-right: 2px;
        .icon_container {
            width: 18px;
            height: 18px;
            border-radius: 2px;
            margin-left: 4px;

            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 13px;
            }
        }
    }

    .body {
        white-space: pre-line;
        font-size: ${props => (props.bodyFontSize ? props.bodyFontSize : '16px')};
        font-weight: ${props => (props.bodyFontWeight ? props.bodyFontWeight : '500')};
    }

    .button-box {
        display: flex;
        height: 28px;
        position: absolute;
        bottom: 18px;
        right: 18px;
        .left-button {
            padding: 0;
            width: ${props => (props.leftButtonSize ? props.leftButtonSize : '68px')};
            font-size: ${props => (props.leftButtonFontSize ? props.leftButtonFontSize : '14px')};
            font-weight: ${props => (props.leftButtonFontWeight ? props.leftButtonFontSize : '500')};
        }
        .right-button {
            padding: 0;
            width: ${props => (props.rightButtonSize ? props.rightButtonSize : '68px')};
            font-size: ${props => (props.rightButtonFontSize ? props.rightButtonFontSize : '14px')};
            font-weight: ${props => (props.rightButtonFontWeight ? props.rightButtonFontWeight : '500')};
        }
    }

    &:focus {
        outline: none;
    }
`;

interface ModalProps {
    open: boolean;
    title?: string;
    titleFontSize?: string;
    titleFontWeight?: string;
    body?: string;
    bodyFontSize?: string;
    bodyFontWeight?: string;
    leftButtonText?: string;
    leftButtonOnClick?: () => void;
    rightButtonText?: string;
    rightButtonOnClick?: () => void;
    rightButtonSize?: string;
    setWidth?: string;
    setHeight?: string;
    style?: CSSProperties;
}

const Modal: React.FC<ModalProps> = ({
    open,
    bodyFontSize,
    title,
    titleFontSize,
    titleFontWeight,
    body,
    children,
    leftButtonText,
    leftButtonOnClick,
    rightButtonText,
    rightButtonOnClick,
    rightButtonSize,
    setWidth,
    setHeight,
    style,
}) => {
    const { t } = useTranslation();

    return (
        <MaterialUIModal
            open={open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <StyledModal
                    setWidth={setWidth}
                    setHeight={setHeight}
                    titleFontSize={titleFontSize}
                    titleFontWeight={titleFontWeight}
                    bodyFontSize={bodyFontSize}
                    rightButtonSize={rightButtonSize}
                    style={style}
                >
                    {title && <div className="title">{title}</div>}
                    {children}
                    {body && <div className="body">{body}</div>}
                    <div className="button-box">
                        {leftButtonText && (
                            <Button className="left-button" onClick={leftButtonOnClick}>
                                {leftButtonText ? leftButtonText : t('cancel')}
                            </Button>
                        )}
                        {rightButtonText && (
                            <Button className="right-button" onClick={rightButtonOnClick}>
                                {rightButtonText ? rightButtonText : t('confirm')}
                            </Button>
                        )}
                    </div>
                </StyledModal>
            </Fade>
        </MaterialUIModal>
    );
};

export default Modal;
